import { useFetch } from '@/hooks/use-fetch'
import React, { useState } from 'react'
import SlideEffect from '@/assets/sounds/slide.mp3'
import { MdiGithub } from './icons'
import RepoCard from './repo-card'

type Props = {}

const RepoTab = (props: Props) => {
    const githubProfiles = [
        {
            endpoint: "https://api.github.com/users/1ces/repos",
            name: "1CEs",
            profile: "https://avatars.githubusercontent.com/u/174105353?v=4"
        },
        {
            endpoint: "https://api.github.com/users/isongwuts/repos",
            name: "ISongwuts",
            profile: "https://avatars.githubusercontent.com/u/93808600?v=4"
        },
    ]

    const [profileSelector, setProfileSelector] = useState<string>(githubProfiles[0].endpoint)
    const { data, loading, error } = useFetch<RepoType[]>(profileSelector)

    if(loading) {
        return (
            <div className='flex justify-center items-center h-[30vh] w-[30vh]'>
                <MdiGithub className='animate-spin' />
            </div>
        )
    }

    return (
        <div className='flex flex-col gap-y-4'>
            <ul className='flex gap-x-4 pt-2'>
                {githubProfiles.map((profile: typeof githubProfiles[0], index: number) => (
                    <li
                    onClick={() => {
                        new Audio(SlideEffect).play()
                        setProfileSelector(profile.endpoint)
                    }}
                    key={index} 
                    className={`
                        flex gap-x-2 items-center 
                        border cursor-pointer
                        p-2 rounded-lg ${profile.endpoint === profileSelector ? 'border-blue-500 text-blue-500' : 'border border-gray-400 '}`
                    }
                        >
                        {profile.endpoint === profileSelector && <div className='h-3 w-3 bg-blue-500 rounded-full'/>}
                        <img src={profile.profile} alt="github profile" className='w-8 h-8 rounded-full' />
                        <span className='font-bold'>{profile.name}</span>
                    </li>
                ))}
            </ul>
            <ul className='flex flex-col gap-y-2 w-full'>
                {data && data.length === 0 && (<span>Cannot load repositories</span>)}
                {
                    data?.map((repo: RepoType, index: number) => (
                        <RepoCard key={index} repo={repo} />
                    ))
                }
            </ul>
        </div>
    )
}

export default RepoTab